import Image, { StaticImageData } from 'next/image'
import styles from './style.module.css'

import type { JSX } from "react";

const Title: React.FC<{children?: JSX.Element | string, image?: string | StaticImageData}> = ({children, image}) => {
  return (
    <>
      <div className={styles.title}>
        {image ? (
            <Image className={styles.image} src={image} width='600' height='600' alt='Title Picture'/>
        ) : null}
        {children}
      </div>
    </>
  )
}

export {
  Title
}